import { defineStyleConfig } from '@chakra-ui/react';

const baseStyle = {
  borderRadius: '1em',
  fontSize: '0.875rem',
};

export const tooltipTheme = defineStyleConfig({ baseStyle });
